<template>
    <v-dialog v-model="isOpen" width="800" :retain-focus="false">
        <v-card 
            class="pa-4"
            flat
            width="800"
        >
            <v-card-title class="">
                <h1 class="font-weight-light primary--text">Nómina</h1>
            </v-card-title>
            <v-card-text>
                <v-card class=" pt-2 my-1" elevation="0">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Usuario
                        </h4>
                    </v-row> 
                    <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-autocomplete 
                            class="pa-4"
                            :items="comerciales" 
                            v-model="account" 
                            item-text="nombreCompleto"
                            item-value="id" 
                            prepend-icon="mdi-account"
                            persistent-hint 
                            label="Empleado" 
                            clearable
                        >
                        </v-autocomplete>
                    </v-row>
                </v-card>
                <v-card class="pt-2 px-4 my-1" elevation="0">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Fecha
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date"
                                    label="Mes de la nómina"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(date)"
                                >
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-row>
                </v-card>
                <div 
                    id="exportForm"
                    @drop="handleFileDrop"
                    class="bg-grey"
                >
                    <v-icon 
                        v-if="files.length" 
                        large 
                        color="red" 
                        class="deleteBtn"
                        @click="clean()"
                    >mdi-delete</v-icon>
                    <v-container
                        fluid 
                        fill-height
                        class="d-flex justify-center align-center"
                    >
                        <div v-if="files.length == 0" class="d-flex flex-column">
                            <v-icon size="100"> mdi-account-credit-card-outline </v-icon>
                            <div class="text-center overline font-weight-light">
                                Arrastre el archivo con la nómina o haga click para abrir el explorador de archivos
                            </div>
                        </div>
                        <div v-else class="d-flex justify-center">
                            <v-badge class="" color="error" icon="mdi-arrow-up-bold" overlap>
                                <v-icon color="green accent-1" size="100">
                                    mdi-file-document-edit-outline
                                </v-icon>
                                <div class="overline">
                                    <small>{{ files[0].name.slice(0, 15) }}</small>
                                </div>
                                <div class="grey--text overline">
                                    {{ (files[0].size / (1024 * 1024)).toFixed(1) }} MB
                                </div>
                            </v-badge>
                        </div>
                    </v-container>
                    <input
                        :style="files.length ? 'top: 350px' : 'top: 300px'"
                        type="file"
                        name="file-input"
                        @change="handleFileInput"
                    />
                </div>
            </v-card-text>
            <v-card-actions class="mt-4 mb-n4 ">
                <v-spacer></v-spacer>
                <v-btn
                    color="green"
                    @click="save()"
                    depressed
                    :disabled="!files.length || !account"
                    :dark="!(!files.length || !account)"
                >
                    Guardar
                </v-btn>
                <v-btn
                    color="red"
                    text
                    @click="closePaysheetForm()"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        files: [],
        account: null,
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        allowedExtensions: ['pdf'],
    }),
    methods: {
        closePaysheetForm() {
            this.$store.commit('storage/userPaysheetsIsOpen', false);
        },
        clean(){
            this.files = [];
        },
        save(){
            let upload = {}
            upload['paysheet'] = this.files[0];
            upload['account'] = this.account;
            upload['month'] = this.date;
            this.$store.dispatch('storage/uploadUserPaysheet', upload);
            this.isOpen = false;
        },
        handleFileDrop(e) {
            let droppedFiles = e.dataTransfer.files;
            let fileExtention = droppedFiles[0].name.split('.').pop();

            if (!droppedFiles) return;
            else {
                this.files = [];

                    if (this.allowedExtensions.includes(fileExtention)) {
                        this.files.push(droppedFiles[0]);
                    } else {
                        this.$store.dispatch(
                            'util/showStatusSnackBar',
                            {
                                statusType: 'error',
                                message:
                                    'El archivo ' +
                                    droppedFiles[0].name +
                                    ' no es del tipo correcto',
                            },
                            { root: true }
                        );
                    }
            }
        },
        handleFileInput(e) {
            let files = e.target.files;
            let fileExtention = files[0].name.split('.').pop();

            if (!files) return;
            else {
                this.files = [];

                if (this.allowedExtensions.includes(fileExtention)) {
                    this.files.push(files[0]);
                } else {
                    this.$store.dispatch(
                        'util/showStatusSnackBar',
                        {
                            statusType: 'error',
                            message:
                                'El archivo ' +
                                files[0].name +
                                ' no es del tipo correcto',
                        },
                        { root: true }
                    );
                }
            }
        },
    },
    computed: {
        isOpen: {
            get() {
                return this.$store.state.storage.userPaysheets.isOpen;
            },
            set(value) {
                this.$store.commit('storage/userPaysheetsIsOpen', value);
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
    },
}
</script>

<style scoped>
.deleteBtn {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 10px;
}

#exportForm input {
    cursor: pointer;
    opacity: 0;
    width: 100%;
    height: 100%;
    height: 200px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
}

.bg-grey {
    /* background-color: #f5f5f5; */
    border-radius: 10px;
}
</style>